import { render, staticRenderFns } from "./NoDocumentos.vue?vue&type=template&id=2cf73823&"
import script from "./NoDocumentos.vue?vue&type=script&lang=js&"
export * from "./NoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports